<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">

    <doctor-assistan-modal ref="assistanModal"></doctor-assistan-modal>
    <doctor-assistant-relation-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></doctor-assistant-relation-form>
  </j-modal>
</template>

<script>

  import DoctorAssistantRelationForm from './DoctorAssistantRelationForm'
  import DoctorAssistantModal from './modules/DoctorAssistantModal'

  export default {
    name: 'DoctorAssistantRelationModal',
    components: {
      DoctorAssistantRelationForm,
      DoctorAssistantModal
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>